import { Location } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
	selector: 'app-image-item-expansive',
	template: `
		<div class="img-container">
			<div class="close-button" (click)="onClose()">
				<mp-icon name="close-outline"></mp-icon>
			</div>
			<img #img [src]="src" [alt]="alt" [style.height.px]="imgHeight" (load)="onImageLoad()">
			<div class="expand-button" *ngIf="isExpandable" (click)="toggle()">
				<mp-icon [name]="expanded ? 'chevron-up-outline' : 'chevron-down-outline'"></mp-icon>
			</div>
		</div>
	`,
	styleUrls: ['./image-item-expansive.component.scss'],
})
export class ImageItemExpansiveComponent {

	@Input() src: string;
	@Input() alt: string;
	@Output() closed = new EventEmitter<void>();
	@ViewChild('img') imgRef: ElementRef<HTMLImageElement>;

	constructor(private location: Location) {}

	expanded = false;
	isExpandable = false;
	collapsedHeight = 300;
	imgHeight = this.collapsedHeight;
	private naturalRenderedHeight = 0;

	onImageLoad() {
		const img = this.imgRef.nativeElement;
		this.naturalRenderedHeight = img.offsetWidth * (img.naturalHeight / img.naturalWidth);
		this.isExpandable = this.naturalRenderedHeight > this.collapsedHeight;
		if (!this.isExpandable) {
			this.imgHeight = this.naturalRenderedHeight;
		}
	}

	toggle() {
		this.expanded = !this.expanded;
		this.imgHeight = this.expanded ? this.naturalRenderedHeight : this.collapsedHeight;
	}

	onClose() {
		if (this.closed.observers.length > 0) {
			this.closed.emit();
		} else {
			this.location.back();
		}
	}
}
